import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PartnerGamesPage.module.scss';
import clsx from 'clsx';
import Block from '../../components/Block/Block';
import Layout from '../../components/Layout/Layout';
import { useFieldArray, useForm } from 'react-hook-form';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import Link from '../../components/Link/Link';
import { gameList } from '../../redux/actions/game/gameList';
import useModalAddNewGame from '../../components/useModalAddNewGame/useModalAddNewGame';
import { gamePartnerAdd } from '../../redux/actions/game/gamePartnerAdd';
import { toast } from 'react-toastify';
import { resetGamePartnerAdd } from '../../redux/slices/game.slice';
import PartnerGameAdd from '../../components/PartnerGameAdd/PartnerGameAdd';
import PartnerGameList from '../../components/PartnerGameList/PartnerGameList';

const PartnerGamesPage = () => {
  return (
    <>
      <Layout>
        <div className={clsx(styles.wrap)}>
          <PartnerGameAdd />
          <PartnerGameList />
        </div>
      </Layout>
    </>
  );
};

export default PartnerGamesPage;
